module.exports = __webpack_public_path__ + "img/area_9.3622926f.png";